export const progress = (state) => state.progress;
export const progressLoading = (state) => state.progressLoading;
export const progressError = (state) => state.progressError;
